import React from "react";
import App from "./App";
import { useLDVariants } from "./v2/context/LaunchDarklyProvider";
import { LoginV2 } from "./v2/pages/LoginV2";

export function AppWrapper() {
  const { flags } = useLDVariants();

  if(flags.caduLogin) {
    return <LoginV2 />;
  }

  return <App />;
} 